export default "__VITE_ASSET__L_NrSX$6__"